import { useMemo } from 'react';

import { useDynamicSaga } from '@/domains/core/applicationState/hooks/useDynamicSaga';
import { createIsolatedWatchAddToCartSaga } from '@/domains/productDiscovery/Recommendation/modules/ProductBundle/sagas/WatchAddToCart/watchAddToCart.saga';

export const useWatchAddToCartRecommendations = (productsIds: string[]) => {
  const saga = useMemo(
    () => createIsolatedWatchAddToCartSaga(productsIds),
    [productsIds],
  );

  useDynamicSaga('shoppingCart.addToCartBundle', saga);
};
